export default __webpack_public_path__ + "static/media/card.e7567f4a.svg";